import { render, staticRenderFns } from "./widget_directionality.vue?vue&type=template&id=37d5d3fe&scoped=true&"
import script from "./widget_directionality.vue?vue&type=script&lang=js&"
export * from "./widget_directionality.vue?vue&type=script&lang=js&"
import style0 from "./widget_directionality.vue?vue&type=style&index=0&id=37d5d3fe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37d5d3fe",
  null
  
)

export default component.exports